import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { CTABand } from "@/components/CTABand";
import { FaqAccordion } from "@/components/FaqAccordion";
import { FAQ_ITEMS } from "@/data/content";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <Seo title="Frequently Asked Questions" description="Answers to common questions about My Geeks LLC services, quotations, payment, cancellation, ownership and how we work." />
      <PageHeader overline="Frequently asked questions" title="Common questions, answered" lede="What we do, how pricing works, how to pay, how to cancel and who owns the work — answered plainly." />
      <section className="mx-auto max-w-4xl px-4 py-16 sm:px-6 md:py-20">
        <FaqAccordion items={FAQ_ITEMS} />
      </section>
      <CTABand title="Still have a question?" text="Ask it directly — by form, email or telephone." />
    </div>
  );
}
